import React from 'react';

import { Row, Col } from 'components/layout';
import Icon from 'components/Icon';

import Feedback from '../Feedback';

const MaintenanceModeView = () => (
  <Row justify="center" align="middle" style={{ height: '100%' }}>
    <Col style={{ textAlign: 'center' }}>
      <Feedback
        title="Maintenance in progress"
        message={''}
        img={<Icon name="alert-triangle" color="#B9C2C9" />}
      />
    </Col>
  </Row>
);

export default MaintenanceModeView;